import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import FifthWheel from './fifth-wheel';
import FifthWheelDetail from './fifth-wheel-detail';
import FifthWheelUpdate from './fifth-wheel-update';
import FifthWheelDeleteDialog from './fifth-wheel-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FifthWheelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FifthWheelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FifthWheelDetail} />
      <ErrorBoundaryRoute path={match.url} component={FifthWheel} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={FifthWheelDeleteDialog} />
  </>
);

export default Routes;
